//test
const getters = {
    sidebar: state => state.app.sidebar,
    language: state => state.app.language,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    status: state => state.user.status,
    roles: state => state.user.roles,
    setting: state => state.user.setting,
    permission_routers: state => state.permission.routers,
    operator: state => state.permission.operator,
    addRouters: state => state.permission.addRouters,
    errorLogs: state => state.errorLog.logs
  }
  export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js